<template>
  <div class="page-wrapper">
    <!-- <b-table striped hover :items="items" :fields="fields"></b-table> -->
    <b-form class="p-3 row align-items-center">
        <b-form-group label="Start Date" class="text-left col-sm-4 start-date">
            <b-form-group>
                <b-form-datepicker
                    v-model="form.date_s"
                    size="sm"
                    required/>
            </b-form-group>
            <!-- <b-form-group>
                <b-form-timepicker
                    v-model="form.time"
                    size="sm"
                    required/>
            </b-form-group> -->
        </b-form-group>
        <b-form-group label="End Date" class="text-left col-sm-4 end-date">
            <b-form-group class="date_picker_add">
                <b-form-datepicker 
                    v-model="form.date_e"
                    size="sm"
                    required/>
            </b-form-group>
            <!-- <b-form-group>
                <b-form-timepicker
                    v-model="form.time"
                    size="sm"
                    required/>
            </b-form-group> -->
        </b-form-group>
        <b-button-group class="tasklistpop w-100 col-sm-2 filter-btn">
            <vue-multi-select
                ref="multiSelect"
                class="multiSelectdiv"
                :options="options11"
                :btnLabel="FilterCheckboxLabel"
                :selectOptions="TaskDataCheckbox">
                <template v-slot:option="{option}">
                    
                    <label :for='option.tagname' v-if="option.hasOwnProperty('tagname')"
                    style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                    <input type="checkbox" 
                    :id="option.tagname" 
                    :value="option.tagname" 
                    @change="checkFilterByTagValue($event)">
                    {{option.name}}</label>

                    <label :for='option.stagename' v-if="option.hasOwnProperty('stagename')"
                    style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                    <input type="checkbox" 
                    :id="option.stagename" 
                    :value="option.stagename" 
                    @change="checkFilterByStageValue($event)">
                    {{option.name}}</label>
                    
                    <label :for='option.OfficeId' v-if="option.hasOwnProperty('OfficeName')"
                    style="width: 100%; margin-bottom: 0px;padding:5px; font-size:15px;">
                    <input type="checkbox" 
                    :id="option.OfficeId" 
                    :value="option.OfficeId" 
                    @change="checkFilterByOfficeValue($event)">
                    {{option.name}}</label>

                </template>
            </vue-multi-select>
        </b-button-group>
        <b-button-group class="w-100 col-sm-2 filter-btn">
            <b-button variant="outline-primary" @click="applyFilter">Filter</b-button>
        </b-button-group>
    </b-form>
    
    <b-table 
        bordered 
        striped 
        responsive 
        hover 
        class="mx-auto text-left middle-grid-sc"
        :items="unCompeletedTaskList"
        :fields="fields"
        @row-clicked="emitToProspInfo"
        sort-by="DueOn"
        :sort-desc="true"
    >
        <template #head(index)>
            <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-6 float-right pr-0">
                        <div class="form-group checkbox-right">
                            <b-form-checkbox 
                                    class="custom-checkbox-fill" 
                                    @change="selectAllCheckbox()"
                                    v-model="isAllTaskSelect" 
                                    name="checkbox-2">
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 float-left pl-0">
        
                        <b-dropdown  class="custom-top-dropdown">
                            <b-dropdown-header>Actions</b-dropdown-header>
                            <b-dropdown-item-button @click.stop.prevent="actionClick(1)"> Complete </b-dropdown-item-button>
                            <b-dropdown-item-button @click.stop.prevent="actionClick(2)"> Delete </b-dropdown-item-button>
                        </b-dropdown>
                    </div>
                </div>
        </template>
        <template #cell(index)="row">
            <div class="form-group UIinsidecheckBox" @click.stop="singleCheckClick()">
                <b-form-checkbox class="custom-checkbox-fill" v-model="row.item.isTaskSelect" name="checkbox-1"></b-form-checkbox>
            </div>
        </template>
        <template #cell(action)="row">
            <div>
                <b-button v-if="row.item.Status != 'compeleted'"
                    style="right: 80px; position: unset; margin-top: 8px; padding: 0px;"
                    variant="outline"
                    class="center-vert"
                    @click="compeleteTask(row.item,$event)"
                >
                    <v-icon class="text-blue" name="check" />
                </b-button>
                <b-button
                    style="right: 50px; position: unset; margin-top: 8px; padding: 0px 10px;"
                    variant="outline"
                    class="center-vert"
                    @click="removeTask(row.item,$event)"
                >
                    <v-icon class="text-blue" name="times" />
                </b-button>
            </div>
        </template>
    </b-table>
    
    <!-- <b-table-simple bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
        <b-thead head-variant="light">
            <b-tr class="text-left">
                <th>
            <div class="row">
                 <div class="col-sm-6 col-md-6 col-lg-6 float-right pr-0">
                    <div class="form-group checkbox-right">
                        <b-form-checkbox 
                                class="custom-checkbox-fill" 
                                @change="selectAllCheckbox()"
                                v-model="isAllTaskSelect" 
                                name="checkbox-2">
                        </b-form-checkbox>
                    </div>
                   </div>
                <div class="col-sm-6 col-md-6 col-lg-6 float-left pl-0">
     
                    <b-dropdown  class="custom-top-dropdown">
						<b-dropdown-header>Actions</b-dropdown-header>
						<b-dropdown-item-button @click.stop.prevent="actionClick(1)"> Complete </b-dropdown-item-button>
                        <b-dropdown-item-button @click.stop.prevent="actionClick(2)"> Delete </b-dropdown-item-button>
					</b-dropdown>
                 </div>
            </div>
                </th>
                <b-th><span> Name</span></b-th>
                <b-th><span>Task</span></b-th>
                <b-th><span>Status</span></b-th>
                
                <b-th><span>Due Date</span></b-th>
                <b-th><span>Action</span></b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr
                :key="task.Task"
                class="text-left position-relative"
                v-for="task in propsTaskList"
                @click="emitToProspInfo(task)"
            >
                <td> 
                    <div class="form-group" @click.stop="singleCheckClick()">
						<b-form-checkbox class="custom-checkbox-fill"   v-model="task.isTaskSelect" name="checkbox-1"></b-form-checkbox>
					</div>
                </td>
                <b-td style="width: 150px;">{{task.FirstName}} {{task.LastName}}</b-td>
                
                <b-td>{{task.Task}}</b-td>
                <b-td style="width: 150px;">{{task.Status}}</b-td>
                <b-td style="width: 150px;">{{$parseDate(task.DueDate)}}</b-td>
                <b-td class=" position-relative" style="width: 150px;">
                    <b-button v-if="task.Status != 'compeleted'"
                            style="right: 80px"
                            variant="outline"
                            class="center-vert"
                            @click="compeleteTask(task,$event)"
                        >
                            <v-icon class="text-blue" name="check" />
                        </b-button>
                        <b-button
                            style="right: 50px"
                            variant="outline"
                            class="center-vert"
                            @click="removeTask(task,$event)"
                        >
                            <v-icon class="text-blue" name="times" />
                    </b-button>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple> -->

  </div>
</template>

<script>
    import vueMultiSelect from 'vue-multi-select';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
	import { db } from 'src/db'
	import { mapState } from 'vuex'
    import moment from 'moment';

	export default {
		name: "Tasklist",
        components: {
            vueMultiSelect,
        },
		computed: {
            ...mapState('firebase', ['user', 'prospects', 'campaigns','emails'])
		},
        created() {
            this.FilterByTagsAndStages();
            this.propsTaskList1();
        },
		methods: {
            propsTaskList1() {
                this.unCompeletedTaskList = [];
                if (this.prospects.length) {
                    for(let p of this.prospects) {
                        if (p.Tasks) {
                            for(let t of p.Tasks) {
                                let singleTask = {
                                        'FirstName':this.getTaskName(p.First, p.Last),
                                        'LastName':p.Last,
                                        'Status':(p.hasOwnProperty('Status') && p.Status ? p.Status :'--'),
                                        'Task':t.Description,
                                        'DueDate':this.getDueDate(t.DueOn),
                                        'singleProsp':p,
                                        'CreatedOn':t.CreatedOn,
                                        'Tags':p.Tags,
                                        'DueOn':t.DueOn,
                                        'Office':p.Office,
                                        "isTaskSelect":false,
                                    }
                                if (this.form.s_date && this.form.e_date) {

                                    let convertedSDate = moment(this.form.s_date).valueOf();
                                    let convertedEDate = moment(this.form.e_date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).valueOf();
                                    
                                    if ( t.Status == 'draft' && (t.DueOn >= convertedSDate && t.DueOn <= convertedEDate)) {
                                        this.unCompeletedTaskList.push(singleTask);
                                    }
                                }else {
                                    if(this.isToday(new Date(t.DueOn))) {
                                        this.unCompeletedTaskList.push(singleTask)
                                    }
                                }
                            }
                        }
                    }
                    
                }

                //eslint-disable-next-line
                //console.log("unCompeletedTaskList", this.unCompeletedTaskList);

                this.tagStageOfficeFilterData();
            },
            tagStageOfficeFilterData() {
                // OFFICE FILTER
                if(this.array3 && this.array3.length) {
                    let filterPorspects2= [];
                    this.array3.forEach(e=>{
                        let s = this.unCompeletedTaskList.filter(pr => pr.Office == e);
                        filterPorspects2 = [...filterPorspects2, ...s];
                    });
                    // eslint-disable-next-line
                    console.log('OFFICE FILTER DATA', filterPorspects2);
                    this.unCompeletedTaskList = [...filterPorspects2];
                }
                // STAGE FILTER
                if(this.array2 && this.array2.length) {
                    let filterPorspects= [];
                    this.array2.forEach(e=>{
                        let s = this.unCompeletedTaskList.filter(pr => pr.Status == e);
                        filterPorspects = [...filterPorspects, ...s];
                    });
                    // eslint-disable-next-line
                    console.log('STAGE FILTER DATA', filterPorspects);
                    this.unCompeletedTaskList = [...filterPorspects];
                }
                // TAG FILTER
                if(this.array1 && this.array1.length) {
                    let filterPorspects1= [];
                    var ne = this.unCompeletedTaskList.map((item)=>{
                    var tmp = item.Tags.filter(subitem=>this.array1.includes(subitem));
                        if(tmp.length > 0) {
                            return item;
                        }
                    });
                    var data = ne.filter(function( element ) {
                        return element !== undefined;
                    });
                    filterPorspects1 = [...filterPorspects1, ...data];
                    // eslint-disable-next-line
                    console.log('TAG FILTER DATA', filterPorspects1);
                    this.unCompeletedTaskList = [...filterPorspects1];
                }
                // return this.unCompeletedTaskList.sort((a, b) => a.DueDate - b.DueDate);
                return this.unCompeletedTaskList.sort((a, b) => a.DueOn - b.DueOn);
            },
            // ON CHANGE TAG EVENT FIRE
            checkFilterByTagValue(event) {
                if(event.target.checked == true) {
                    this.array1.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array1.splice(this.array1.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1;
                }
                //eslint-disable-next-line
                console.log("array1", this.array1);
            },
            // ON CHANGE STAGE EVENT FIRE
            checkFilterByStageValue(event) {
                if(event.target.checked == true) {
                    this.array2.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array2.splice(this.array2.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1;
                }
                //eslint-disable-next-line
                console.log("array2", this.array2);
            },
            // ON CHANGE OFFICE EVENT FIRE
            checkFilterByOfficeValue(event) {
                if(event.target.checked == true) {
                    this.array3.push(event.target.value);
                    this.FilterByCount = this.FilterByCount + 1; 
                } else {
                    this.array3.splice(this.array3.indexOf(event.target.value), 1);
                    this.FilterByCount = this.FilterByCount - 1;
                }
                this.array3 = this.array3.map((i) => Number(i)) // ['313', '176'] to [313,176]
                //eslint-disable-next-line
                console.log("array3", this.array3);
            },
            TagNameData() {
                let FolderDataArray = [];
                this.user.Folders.forEach(tl=>{
                    FolderDataArray.push({tagname:tl, name:tl});
                })
                return FolderDataArray;
            },
            StageNameData() {
                let StagesDataArray = [];
                this.user.Stages.forEach(tl=>{
                    StagesDataArray.push({stagename:tl, name:tl});
                })
                return StagesDataArray;
            },
            OfficeNameWithName() {
                let OfficeData = [];
                Object.assign(OfficeData,this.user.Offices)
                OfficeData.forEach(uo => {
                    uo['name'] = uo.OfficeName;
                });
                return OfficeData;
            },
            FilterByTagsAndStages() {
                this.TaskDataCheckbox.push({
                    name:'Tags',
                    list:this.TagNameData()
                },{
                    name:'Stages',
                    list:this.StageNameData()
                },{
                    name:'Offices',
                    list:this.OfficeNameWithName()
                })
            },
            // DISPLAY FILTER BY COUNT
            FilterCheckboxLabel() {
                return 'Filter By ('+this.FilterByCount+')';
            },
            rowClass(item) {
                //eslint-disable-next-line
                console.log('item', item);
                return 'table-success'
            },
            // TABLE NAME
            getTaskName(first,last) {
                return first+' '+last;
            },
            // TABLE DUE DATE
            getDueDate(duedate) {
                return this.$parseDate(duedate);
            },
            customSorting(a, b, key) {
                //eslint-disable-next-line
                console.log('SORTTT');
                if (typeof a[key] === "number" && typeof b[key] === "number") {
                    // If both compared fields are native numbers
                    return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
                } else {
                    // Stringify the field data and use String.localeCompare
                    return this.toStringMthod(a[key]).localeCompare(
                    this.toStringMthod(b[key]),
                    undefined,
                    {
                        numeric: true
                    }
                    );
                }
            },
            isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
            },
            applyFilter() {
                this.isAllTaskSelect = false;
                this.form.s_date = this.form.date_s;
                this.form.e_date = this.form.date_e;
                this.propsTaskList1();
            },
            removeTask(key,event) {
                if (confirm("Are you sure you want to delete this task?")) {
                    event.stopPropagation();
                    let i=0;
                    let tasks = key.singleProsp.Tasks
					for (let t of tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							tasks.splice(i,1)
						}
						i++;
                    }
                    db.doc(`Users/${this.user.id}/Prospects/${key.singleProsp.id}`).update({Tasks:tasks});
                    setTimeout(() => {
                        this.propsTaskList1();
                    }, 100);
                }
			},
            commonCreateNotes(notesAdd, key) {
				var notesArray1 = [];
				var nt = [];
                Object.assign(nt,key.singleProsp.Notes) ;
				if(key.singleProsp.hasOwnProperty('Notes') && nt != null || nt != undefined) {
					notesArray1 = nt;
				}
				let notesArray2 = [{
					'date': Date.now(),
					'description': notesAdd,
					'mediaURL': ''
				}];
				let notesFinalArray = [...notesArray1, ...notesArray2];
				db.doc(`Users/${this.user.id}/Prospects/${key.singleProsp.id}`).update({ Notes: notesFinalArray })
                .catch(err => {
					this.$emit('error', err);
				});
			},
			compeleteTask(key,event) {
				if (confirm("Are you sure you want to mark this task as completed?")) {
					// let i=0;
                    event.stopPropagation();
                    let taskDesc = '';
                    let tasks = key.singleProsp.Tasks
					for (let t of tasks) {
						if (key.CreatedOn == t.CreatedOn) {
                            t.Status = 'compeleted';
                            t.CompletedOn = Date.now();
							// tasks.splice(i,1)
							taskDesc = t.Description;
						}
						// i++;
					}
					db.doc(`Users/${this.user.id}/Prospects/${key.singleProsp.id}`).update({Tasks:tasks});
                    setTimeout(() => {
                        this.propsTaskList1();
                    }, 100);
					let noteMsg = "Task "+ taskDesc + " was completed";
                    this.commonCreateNotes(noteMsg, key);
                    /*
                    let noteList = key.singleProsp.Notes;
					let firstNote = {};
					if (!noteList) {
						firstNote[Date.now()] = noteMsg;
					} else if (Object.keys(noteList).length > 0) {
						noteList[Date.now()] = noteMsg;
						firstNote = noteList;
					} else {
						firstNote[Date.now()] = noteMsg;
					}
					db.doc(`Users/${this.user.id}/Prospects/${key.singleProsp.id}`).update({Notes:firstNote});
                    */
                }
            },
            async emitToProspInfo(task) {
                let convo = this.$store.state.firebase.convos.find(convo => convo.ClientNumber == task.singleProsp.Number);
                
                if (!convo) {
					convo = await db.collection('Conversations').add({
						ClientNumber: task.singleProsp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: task.singleProsp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id);
                if (this.emails.length) {
                    let mid = this.getEmailConvoID(task.singleProsp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
                    // this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(task.singleProsp.id));
                }
				this.$emit('open','prosp');
            },
            getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
            // itemsProvider(ctx, callback) {
            //     getSubUserList({UID: this.user.id})
			// 	.then((res) => {
            //       const items =  this.initTable(res)
            //       callback(items)
            //     })
            //     .catch(err => alert(`Failure getting sub user list: ${err}`));
            //     return null
            // },
            // initTable(res) {
			// 	let itemArray = [];
            //     for (let su of res.data) {
            //         itemArray.push(su);
			// 	}
            //     return itemArray;
            // }
            selectAllCheckbox() {
                this.unCompeletedTaskList.map(i=>i.isTaskSelect=!this.isAllTaskSelect);
			},
            singleCheckClick() {
			},
            actionClick(no) {
                let pidsArray = [];
                let selectedTaskList = [];
                // if (this.isAllTaskSelect) {
                //     // pidsArray = Object.keys(this.uniqueTaskProspect(this.propsTaskList));
                //     pidsArray = this.uniqueTaskProspect(this.propsTaskList);
                //     selectedTaskList = this.propsTaskList;
                // }else {
                    let items = this.unCompeletedTaskList.filter(pt => pt.isTaskSelect == true);
                    // pidsArray = Object.keys(this.uniqueTaskProspect(items));
                    pidsArray = this.uniqueTaskProspect(items);
                    selectedTaskList = items;
                // }

                //eslint-disable-next-line
                console.log(pidsArray)
                if (no == 1) {
                    this.completeBulkTask(pidsArray,selectedTaskList);
                }
                else if (no == 2) {
                    this.deleteBulkTask(pidsArray,selectedTaskList);
                }
                this.isAllTaskSelect = false;
                setTimeout(() => {
                    this.propsTaskList1();
                }, 100);
            },
            async completeBulkTask(pidsArray,selectedTaskList) {
                if (confirm("Are you sure you want to mark selected task as completed?")) {
                    Object.keys(pidsArray).forEach(key => {
                        let tasks = pidsArray[key].Tasks;
                        let noteList = pidsArray[key].Notes;
                        var notesArray1 = [];
                        for (let t of tasks) {
                            let ft = selectedTaskList.find(tk => tk.CreatedOn == t.CreatedOn);
                            if (ft) {
                                t.Status = 'compeleted';
                                t.CompletedOn = Date.now();
                                let noteMsg = "Task "+ t.Description + " was completed";
                                if(pidsArray[key].hasOwnProperty('Notes') || noteList != null || noteList != undefined) {
                                    notesArray1 = noteList;
                                }
                                notesArray1.push({
                                    'date': Date.now(),
                                    'description': noteMsg,
                                    'mediaURL': ''
                                })
                            }
                        }
                        db.doc(`Users/${this.user.id}/Prospects/${key}`).update({ Notes: notesArray1 })
                        db.doc(`Users/${this.user.id}/Prospects/${key}`).update({Tasks:tasks});
                    });
                }
            },
            deleteBulkTask(pidsArray,selectedTaskList) {
                if (confirm("Are you sure you want to delete selected task?")) {
                    Object.keys(pidsArray).forEach(key => {
                        let i=0;
                        let tasks = pidsArray[key].Tasks;
                        for (let t of tasks) {
                            let ft = selectedTaskList.find(tk => tk.CreatedOn == t.CreatedOn);
                            if (ft) {
                                tasks.splice(i,1)
                            }
                            i++;
                        }
                        db.doc(`Users/${this.user.id}/Prospects/${key}`).update({Tasks:tasks});
                    });
                }


                // if (confirm("Are you sure you want to delete this task?")) {
                //     event.stopPropagation();
                //     let i=0;
                //     let tasks = key.singleProsp.Tasks
				// 	for (let t of tasks) {
				// 		if (key.CreatedOn == t.CreatedOn) {
				// 			tasks.splice(i,1)
				// 		}
				// 		i++;
                //     }
				// 	db.doc(`Users/${this.user.id}/Prospects/${key.singleProsp.id}`).update({Tasks:tasks});
				// }
            },
            uniqueTaskProspect(prospectArray) {
                return prospectArray.reduce((seed, current) => {
                    return Object.assign(seed, {[current.singleProsp.id]: current.singleProsp});
                }, {});
            }
		},
		data() {
            /*var date = new Date();
            var firstDay = new Date(date.getFullYear(), 0, 1);*/
            var firstDay = new Date('01-01-2022');
			return {
                // sortBy: 'age',
                // sortDesc: false,
                fields: [
                'index',
                { key: 'FirstName', label: 'Name', sortable: true },
                { key: 'Task', sortable: true },
                { key: 'Status', sortable: true },
                { key: 'DueDate', label: 'Due Date', sortable: true },
                { key: 'action', label: 'Action', thStyle: { width: "14%" } },
                ],
                form: {
                    date_s:firstDay,
                    date_e:new Date(),
					s_date: firstDay,
					e_date: new Date(),
				},
                isAllTaskSelect:false,

                FilterByCount:0,
                options11: {
                    multi: true,
                    groups: true,
                },
                TaskDataCheckbox: [],
                array1: [],
                array2: [],
                array3: [],
                unCompeletedTaskList: [],


				// fields: ['FirstName','LastName','Status','Task','DueDate'],
                // items:this.itemsProvider
			}
        }
        
        // {key:'Twilio',label: 'taTEXT Number',}
	}
</script>

<style scoped>
.btn-group button.btn.btn-outline-primary{       
    background: #042b79;
    color: #fff;
    border-color: #042b79;
}
.date_picker_add b-form-datepicker{
    top:160px;
}
.page-wrapper{
    height: 100vh;overflow-x: hidden;overflow-y: auto;
}
.checkbox-right{
    width: 100%;
}
.UIinsidecheckBox{
    margin-bottom: 0px;
}
.select.multiSelectdiv .btn-select{
    margin: 0px 15px;
    border-radius: 3px;
    color: #007bff;
    border-color: #007bff;
    padding: 5px 30px;
    background: transparent;
    font-size: 14px;
    line-height: 1.5;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
.select.multiSelectdiv .btn-select:hover{
    background: #007bff;
    color:#fff;
}
.select.multiSelectdiv .btn-select:focus{
    outline:none;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 50%);
}
.select.multiSelectdiv .checkBoxContainer{
    padding: 0px;
    margin: 0px;
}
.select.multiSelectdiv .checkBoxContainer .selectItem {
    padding: 8px;
    margin: 0px;
    font-size: 15px;
    border-bottom: 1px solid #ddd;
}
.select.multiSelectdiv .checkBoxContainer .selectItem:last-child {
    border:none;
}
.tasklistpop{
    padding:0px;
}
</style>
<style>
.tasklistpop .select.multiSelectdiv .btn-select {
    width: 100%;
}
</style>